import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, Slide } from '@mui/material';
import type { TransitionProps } from '@mui/material/transitions';
import { type ReactNode, forwardRef } from 'react';

export interface SlideoverProps {
    title?: string;
    children?: ReactNode;
    open: boolean;
    onClose?: () => void;
}

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="left" ref={ref} {...props} />;
});

export default function Slideover({ open, onClose, title, children }: SlideoverProps) {
    return (
        <Dialog
            PaperProps={{
                className: 'fixed right-0 top-0 bottom-0 !m-0 !max-h-full',
            }}
            open={open}
            onClose={() => onClose?.()}
            TransitionComponent={Transition}
        >
            <DialogTitle className="mb-10 flex justify-between text-base font-semibold leading-6 text-gray-900 dark:text-white">
                {title}
                <div className="flex flex-1 justify-end">
                    <button
                        type="button"
                        className="bg-white text-gray-400 hover:text-gray-500 dark:bg-transparent dark:text-white hover:dark:text-gray-300"
                        onClick={() => onClose?.()}
                    >
                        <span className="sr-only">Close panel</span>
                        <CloseIcon />
                    </button>
                </div>
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
        </Dialog>
    );
}
